import { render } from "./SalesForce.vue?vue&type=template&id=d08fc45c&scoped=true"
import script from "./SalesForce.vue?vue&type=script&lang=js"
export * from "./SalesForce.vue?vue&type=script&lang=js"

import "./custom-salesforce.scss?vue&type=style&index=0&id=d08fc45c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d08fc45c"]])

export default __exports__